import {  addSeconds } from 'date-fns';
/**
 * If the path is a string, convert it to an array
 * @param  {String|Array} path The path
 * @return {Array}             The path array
 * @example get(object, 'a[0].b.c', 1);
 * Note: If provided path does not exists inside the object js will generate error.
*/
const get = (obj, path, defaultValue) => {
  const result = String.prototype.split.call(path, /[,[\].]+?/)
    .filter(Boolean)
    .reduce((res, key) => (res !== null && res !== undefined) ? res[key] : res, obj);
  return (result === undefined || result === obj) ? defaultValue : result;
};
const expiresDate = (seconds) => {
  return addSeconds(new Date(), seconds);
}
const decodeToken = token => {
  if (token) {
    return JSON.parse(atob(token.split(".")[1]));
  } else return null;
};
const isTokenExpired = token => {
  var decode = decodeToken(token);
  if (!decode || decode.exp < Date.now() / 1000) {
    return true;
  } else {
    return false;
  }
};

export default {
  get,isTokenExpired,expiresDate,decodeToken
};
